import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import LightTooltip from '../components/LightTooltip';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const DialogTitleWithCloseButton = withStyles(theme => ({
  root: {
    display: 'flex',
    margin: 0,
    padding: '13px 13px 13px 16px'
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    color: theme.palette.grey[500],
    top: '13px'
  },
  title: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '24px',
    display: 'inline'
  },
  helpIconContainer: {
    display: 'inline',
    verticalAlign: 'middle',
    cursor: 'pointer',
    paddingLeft: '4px'
  },
  helpIcon: {
    verticalAlign: 'middle',
    color: '#757575'
  }
}))(props => {
  const { children, classes, onClose, help } = props;
  const [open, setOpen] = React.useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography className={classes.title} variant="h6">
        {children}{' '}
      </Typography>
      {help ? (
        <div className={classes.helpIconContainer}>
          <ClickAwayListener onClickAway={handleTooltipClose}>
            <LightTooltip
              placement="right"
              PopperProps={{
                disablePortal: true
              }}
              onClose={handleTooltipClose}
              open={open}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Batch properties are applied to all the documents inside the batch. But you can also override some of the properties for individual documents, such as security, date, and status."
            >
              <HelpOutlineIcon
                onClick={handleTooltipOpen}
                className={classes.helpIcon}
                data-testid="showTooltip"
              />
            </LightTooltip>
          </ClickAwayListener>
        </div>
      ) : null}
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export default DialogTitleWithCloseButton;
